import { Accessories } from "./_Accessories";
import { BasePage } from "@Tenants/Hc/Site/BasePage";
import { BaseProduct } from "@Base/Product/Product";
import { Tenant } from "../../../Utilities/Tenant";
import { TitleChanger } from "@Utilities/TitleChanger";

import "./Product.scss";

class Product extends BaseProduct
{
	public Accessories: Accessories;

	constructor()
	{
		super();
	}

	public Initialize(): void
	{
		super.Initialize();

		this.Accessories = new Accessories();
		this.ConfigureTitleChanger();
	};

	private ConfigureTitleChanger(): void
	{
		let titleChangerText: string = "";

		if (Tenant.DomainProjectID === Tenant.ID.HalloweenCostumesAU)
		{
			titleChangerText = "👻 Don't Ghost Us!";
		}

		if (Tenant.DomainProjectID === Tenant.ID.HalloweenCostumesUS)
		{
			titleChangerText = "🦇 Don't Fly Away Yet!";
		}

		if (titleChangerText !== "")
		{
			const titleChanger = new TitleChanger(titleChangerText, 10000, 4000);
		}
	}
}

class ProductPage extends BasePage
{
	public Product: Product;
	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
		this.Product = new Product();
	};
}

const product = new ProductPage();